<template>
    <div data-name="interaction-wrapper" :style="position" class="element-wrapper" >

        <!-- <component :is="component" :data-name="type + '-element'" :element="element" /> -->

        <hotspot-element v-if="type === 'App\\HotspotElement'" :element="element"></hotspot-element>
        <button-element v-if="type === 'App\\ButtonElement'" :element="element"></button-element>
        <text-element v-if="type === 'App\\TextElement'" :element="element"></text-element>
        <form-element v-if="type === 'App\\FormElement'" :element="element"></form-element>
        <html-element v-if="type === 'App\\CustomHtmlElement'" :element="element"></html-element>
        <image-element v-if="type === 'App\\ImageElement'" :element="element"></image-element>
    </div>
</template>
<script>
    import hotspotElement from './Hotspot.vue';
    import buttonElement from './Button.vue';
    import TextElement from './Text.vue';
    import FormElement from './Form.vue';
    import HtmlElement from './Html.vue';
    import ImageElement from './Image.vue';
    import scaleProject from "../../mixins/ScaleProject.js";

    export default {
        name:'Element',
        props: ['element', 'type', 'interactionLayerElement'],
        mixins:[
            scaleProject
        ],
        components: {
            hotspotElement, buttonElement, TextElement, FormElement, HtmlElement, ImageElement
        },

        computed: {
            // component(){
            //     switch (this.type) {
                    
            //         case 'App\\HotspotElement':
            //             return 'hotspot-element';
            //         case 'App\\ButtonElement':
            //             return 'button-element';
            //         case  'App\\TextElement':
            //             return 'text-element';
            //         case  'App\\FormElement':
            //             return 'form-element';
            //         case  'App\\CustomHtmlElement':
            //             return 'html-element';
            //         case 'App\\ImageElement':
            //             return 'image-element';
                
            //         default:
            //             return null;
            //     }
            // },
            position(){
                const elementStyle = {
                    ...this.scaledStyles,
                    position:'absolute',
                    willChange: 'transform,opacity,contents',
                    left: (this.interactionLayerElement) ? 0 : this.leftPosition,
                    top: (this.interactionLayerElement) ? 0 : this.topPosition,
                    height:   this.height,
                    width:  this.width,
                    zIndex: this.element.zIndex + 200 ,
                    pointerEvents: 'auto' // 🔥 pretty important for elements to actually click
                }
                return elementStyle
            },

            leftPosition(){
                return this.scaleValue(this.element.posX) + 'px';
            },

            topPosition(){
                return this.scaleValue(this.element.posY) + 'px';
            },

            height(){
                return this.element.height + 'px';
            },

            width(){
                return this.element.width + 'px';
            }
        }
    }
</script>
<style>
    /* ⚡️ This is used in the individual elements components just placed it here to avoid repetiton 🔥 */
    .centeredElement{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    .clickable {
        cursor: pointer;
    }
</style>